// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';

export const Container = styled.div``;

export const DynamicContent = styled.div`
  padding: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
  font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
  font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy2}px;
  font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
  color: ${(props) => props.theme.colorPalette.gray[800]};
  a {
    color: ${(props) => props.theme.colorPalette.gray[800]};
    font-weight: ${(props) => props.theme.fonts.fontWeight.extrabold};
  }

  .chart-list {
    list-style-position: inside;
  }

  .chart-list li {
    padding-left: 10px;
    list-style-type: disc;
  }

  .chart-list li strong,
  .chart-list li a strong {
    font-weight: 800;
  }
`;
